export default __webpack_public_path__ + "static/media/instructor.068a9e59.jpg";